import promiseRetry from 'promise-retry';
export function promiseWithRetries(promiseFn, _ref) {
  let {
    retries,
    onRetry
  } = _ref;
  return promiseRetry((retry, attempt) => promiseFn({
    attempt
  }).catch(error => {
    if (attempt < retries) {
      onRetry(error, attempt);
      return retry(error);
    }
    throw error;
  }));
}
//# sourceMappingURL=promiseWithRetries.js.map